/* eslint-disable no-var */
require('slick-carousel');
require('sticky-kit/dist/sticky-kit.min.js');
require('magnific-popup');

var WebFont =  require('webfontloader');


WebFont.load({
  google: {
    families: [
      'Hind:200,300,400,500,600,700',
      'Roboto:200,300,400,500,600,700,900',
    ],
  },
});

jQuery(document).ready( function ($){
    $('.text-and-images').css('min-height', $('.images-position').height()+100+'px');


    if(!$('.content-wrap').find('.residential-construction.testimonials').hasClass('testimonials')) {
        $('.residential-construction').addClass('none-testimonials')
    }
    //gravity-forms reload
    window.wld_gform_reload = [];

    function WLD_GForm_Reload($gform) {
        this.$parent = $gform.parent();
        this.html = this.$parent.html();
        this.gform_id = parseInt($gform.attr('id').match(/\d+$/)[0]);

        this.reload_form = function () {
            var $message = this.$parent.find('#gform_confirmation_wrapper_' + this.gform_id);

            this.$parent.html(this.html);
            this.$parent.append($message);

            $(document).trigger('gform_post_render', [this.gform_id, 0]);
        };

        this.init = function () {
            var _this = this;

            $(document).bind('gform_confirmation_loaded', function (event, gform_id) {
                if (gform_id === _this.gform_id) {
                    _this.reload_form();
                }
            });
        };

        this.init();

        return this;
    }

    $('.gform_wrapper').each(function () {
        window.wld_gform_reload.push(new WLD_GForm_Reload($(this)));
    });
    var openbtn = document.getElementById('open-button');
    var isOpen = false;
    $(".article-section .col-md-4").stick_in_parent({
        offset_top: 170,
    });
    function toggleMenu() {
        if (isOpen) {
            $('body').removeClass('show-menu');
        } else {
            $('body').addClass('show-menu');
        }
        isOpen = !isOpen;
    }

    $('#open-button').on('click', toggleMenu);
    $('#close-button').on('click', toggleMenu);

    // mobile menu expand/minimize
    var $hasChildrenItem = $('.menu-wrap .menu-item-has-children');
    $hasChildrenItem.prepend('<div class="expand-btn"></div>');
    $('.expand-btn').click(function(event) {
        var $menuItem = $(event.currentTarget).parent();
        var $parentItem = $(event.currentTarget).parent().parent();

        if ($menuItem.hasClass('open')) {
            $parentItem.find('.menu-item-has-children').removeClass('open');
        } else {
            $parentItem.find('.menu-item-has-children').removeClass('open');
            $menuItem.addClass('open');
        }
    });

    var sticky = $('#sticky-header');
    var stickyHeaderTop = 1;
    $(document).on('scroll', function() {
        if ($(window).scrollTop() > stickyHeaderTop) {
            sticky.addClass('fixed').removeClass('unfixed');
        } else {
            sticky.removeClass('fixed').addClass('unfixed');
        }
    });
    if ($(window).scrollTop() > stickyHeaderTop) {
        sticky.addClass('fixed').removeClass('unfixed');
    } else {
        sticky.removeClass('fixed').addClass('unfixed');
    }


    $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea, .gfield select').on('checkval', function(event, param) {
        checkvalFunction (this, event, param);
    }).on('keyup input paste', function() {
        $(this).trigger('checkval', 'focus');
    }).on('blur', function() {
        $(this).trigger('checkval');
    }).focus(function() {
        $(this).trigger('checkval', 'focus');
    }).trigger('checkval');

    // smooth scroll
    $('.scroll-to')
        .click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                event.preventDefault;
                var target = $(this.hash);
                var top = target.offset().top;
                if ($(window).width() > 992) {
                    top = top - 140;
                };
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html,body').animate({
                        scrollTop: top
                    }, 1000);
                }
            }
        });

    $('a[href*="#case-studies"], a[href*="#warranties"], a[href*="#videos"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[href="#applying-form"]')
        .click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                event.preventDefault;
                var target = $(this.hash);
                var top = target.offset().top;
                if ($(window).width() > 992) {
                    top = top - 140;
                };
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html,body').animate({
                        scrollTop: top
                    }, 1000);
                }
            }
        });

    //rating
    $('.rating').each(function(i, item)  {
        var rating = $(item).data('rating');
        var starWidth = $(item).data('star-width');
        var starSpacing = $(item).data('star-spacing');
        $(item).find('.filling-stars').css('width', (rating * starWidth) + (parseInt(rating) * starSpacing) + 'px');
    });

    function checkvalFunction (obj, event, param) {
        var label = $(obj).parent().prev('label');
        if(obj.value !== '' || param == 'focus') {
            label.addClass('show');
        } else {
            label.removeClass('show');
        }
    }

    //form labels
    $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea').on('checkval', function(event, param) {
        checkvalFunction (this, event, param);
    }).on('keyup input paste', function() {
        $(this).trigger('checkval', 'focus');
    }).on('blur', function() {
        $(this).trigger('checkval');
    }).focus(function() {
        $(this).trigger('checkval', 'focus');
    }).trigger('checkval');

    jQuery(document).on('.gform_post_render', function() {
        //confirmation form class
        setTimeout(function () {
            $('.gform_confirmation_wrapper').closest('.footer-form-wrap').addClass('confirmation');
            //form labels
            $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea').on('checkval', function(event, param) {
                checkvalFunction (this, event, param);
            }).on('keyup input paste', function() {
                $(this).trigger('checkval', 'focus');
            }).on('blur', function() {
                $(this).trigger('checkval');
            }).focus(function() {
                $(this).trigger('checkval', 'focus');
            }).trigger('checkval');
        }, 100);
    });

    //process section items hover
    $('.process .item').hover(function (event) {
        $(event.currentTarget).nextAll().removeClass('hover')
        $(event.currentTarget).prevAll().addClass('hover');
    });

    //opening external links in new tab
    $(document.links).filter(function() {
        return this.hostname != window.location.hostname;
    }).attr({
        'target': '_blank',
        'rel': 'noopener'
    });

    //add class to footer
    $('.cta-block').closest('.skills:last-child').closest('.main').siblings('.footer').addClass('after-cta-block');

    //portfolio filter
    $('.portfolio-nav li').click( function(event) {
        $(event.currentTarget).siblings('li').removeClass('active');
        $(event.currentTarget).addClass('active');
        var filterClass = $(event.currentTarget).data('filter');
        $('.portfolio .wrap .item').hide();
        $('.portfolio .wrap .item.' + filterClass).show();
    });




    //single project page sticky content
    var stickRightPart = function () {
        if ($(window).width() >= 993) {

            if ($('.page-top-section .right .text').length) {
                var stickElement = $('.page-top-section .right .text');
                var stopElement = $('.main > section:last-child, .main > div:last-child');
                if (stopElement.hasClass('popup')) {
                    stopElement = stopElement.prev();
                }
                var stopTop = stopElement.offset().top - 430;

                $(window).scroll(function () {
                    var currentScroll = $(window).scrollTop();
                    if (currentScroll > stopTop) {
                        var delta = currentScroll - stopTop;
                        stickElement.css('marginTop', '-' + delta + 'px');
                    } else {
                        stickElement.css('marginTop', 0);
                    }
                });
            }
        } else {
            $('.page-top-section .right').trigger('sticky_kit:detach');
        }
    };

    $('.residential-construction-slick').slick({
        slidesToShow: 2,
        adaptiveHeight: false,
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        initialSlide: 0,
        prevArrow: $('.residential-construction-slick-prev'),
        nextArrow: $('.residential-construction-slick-next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: false,
                    centerMode: false,
                }
            }
        ]
    });




    $('.slick-hero').slick({
        slidesToShow: 1,
        // adaptiveHeight: false,
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000,
        initialSlide: 0,
        prevArrow: $('.arrow-slick-hero-prev'),
        nextArrow: $('.arrow-slick-hero-next'),
        responsive: [
            // {
            //     breakpoint: 767,
            //     settings: {
            //         slidesToShow: 2,
            //         slidesToScroll: 1,
            //         infinite: true,
            //         variableWidth: false,
            //         centerMode: false,
            //         centerPadding: '15px',
            //     }
            // },
            // {
            //     breakpoint: 450,
            //     settings: {
            //         slidesToShow: 1,
            //         slidesToScroll: 1,
            //         infinite: true,
            //         variableWidth: false,
            //         centerMode: false,
            //         centerPadding: '15px',
            //     }
            // },
        ]
    });

    $('.slick-service-we-offer').slick({
        slidesToShow: 3,
        // adaptiveHeight: false,
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        initialSlide: 0,
        prevArrow: $('.service-slick-nav-prev'),
        nextArrow: $('.service-slick-nav-next'),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: false,
                    centerMode: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1 ,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: false,
                    centerMode: false,
                    centerPadding: '15px',
                }
            },
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    variableWidth: false,
                    centerMode: false,
                    centerPadding: '15px',
                }
            },
        ]
    });


    $(window).trigger('resize');


    $('.popup-btn').magnificPopup({
        type: 'inline',
        preloader: false,
    });
    $('.open-video').magnificPopup({
        type: 'iframe',
    });
    $('.open-img').magnificPopup({
        type: 'image',
    });

    //chat and recaptcha position
    function chatAndRecaptchaPosition() {
        if (!$('html').hasClass('has-cookie-bar cookie-bar-bottom-bar')) {
            return;
        };
        var height = parseInt($('#catapult-cookie-bar').outerHeight());
        var styles = '<style>.has-cookie-bar.cookie-bar-bottom-bar body > .container {margin-bottom:' + height + 'px;} .has-cookie-bar.cookie-bar-bottom-bar .mcwidget-embed {bottom:' + parseInt(height - 30) + 'px;} .has-cookie-bar.cookie-bar-bottom-bar .grecaptcha-badge {bottom:' + parseInt(height + 1) + 'px !important;}</style>';
        $('#additional-styles').html(styles);
    }

    $('body').append('<div id="additional-styles"></div>');

    $(window).load(function () {
        chatAndRecaptchaPosition();
    });

    $(window).resize(function () {
        chatAndRecaptchaPosition();
    });

});




// WEBPACK FOOTER //
// ./src/assets/js/init.js